export const FACEBOOK = 'facebook';
export const LINKEDIN = 'linkedin';
export const TWITTER = 'twitter';
